import Component from '../abstracts/Component';

export default class BackToTopComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-back-to-top',
      addToCart: '.product-actions:not(.is-cart-bar) .js-addtocart'
    }
  }

  get CLASSES() {
    return {
      active: 'visible'
    }
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.addToCart = $(this.SELECTORS.addToCart);
  }

  bindEvents() {

    let _this = this;

    this.main.on('click.back-to-top', (e) => {
      _this.log('back to top mobile');
      $('html, body').animate({
        scrollTop: _this.addToCart.offset().top - document.documentElement.clientHeight / 2
      }, 1000);
    });

    $(window).scroll((e) => {
      if (document.documentElement.scrollTop > _this.addToCart.offset().top) {
        _this.main.addClass(_this.CLASSES.active);
      } else {
        _this.main.removeClass(_this.CLASSES.active);
      }
    });

  }

  render() {

    if(this.$matchMedia('sm', null)){
      if (this.main.length) {
        this.bindEvents();
      }
    }

  }
}
